interface IFirstWebERPService {
    ERPStatus: {
        Success: boolean,
        Code: number,
        Message: string
    },
    Data: string
}

module Elma.ViewModels {
    export class InformationViewModel extends Tapas.ViewModels.CartViewModel {
        public userType: KnockoutObservable<number> = ko.observable(1); // get usertype
        public altDelivery: KnockoutObservable<string> = ko.observable(""); // get alternative delivery option
        public currentFormId: KnockoutObservable<string> = ko.observable(""); // init form selector - value is updated via initValue in information.cshtml
        public pageIsUpdating: KnockoutObservable<boolean> = ko.observable(false); // check whether form is submitting
        public nextStep: KnockoutObservable<string> = ko.observable("");
        public currentStep: KnockoutObservable<string> = ko.observable("");
        public targetCheckoutStep: KnockoutObservable<string> = ko.observable("");
        public userTypeText: KnockoutObservable<string> = ko.observable(""); // updates value on a hidden input field with the correct translate tag
        public deliveryText: KnockoutObservable<string> = ko.observable("");
        public preferredWholesaler: KnockoutObservable<string> = ko.observable("");
        public preferredWholesalerValue: KnockoutObservable<string> = ko.observable("");
        public visibleFields: KnockoutObservableArray<any> = ko.observableArray([]);
        public zipCode: KnockoutObservable<string> = ko.observable("");
        public cityName: KnockoutObservable<string> = ko.observable("");
        public altZipCode: KnockoutObservable<string> = ko.observable("");
        public altCityName: KnockoutObservable<string> = ko.observable("");
        public isCompany = ko.observable(false);
        public pickupShippingId = ko.observable("");
        public privateShippingId = ko.observable("");
        public companyShippingId = ko.observable("");
        public loadedChosenShipping = ko.observable("");
        public EcomOrderCustomerCountry = ko.observable("");
        public EcomOrderCustomerCountryName = ko.observable("");
        public EcomOrderDeliveryCountry = ko.observable("");
        private disableAjaxSubmit = ko.observable(false);

        private logger = Ftw.Base.Config.Logger;

        constructor() {
            super();
            
            this.checkoutInit();
            
            this.gtmDataLayer();
           
            this.altZipCode.subscribe((newZip) => {
                this.updateZip(newZip, this.altCityName);
            });

            this.zipCode.subscribe((newZip) => {
                this.updateZip(newZip, this.cityName);
            });

            this.altDelivery.subscribe((newValue) => {                
                if (newValue != "Other" && (this.EcomOrderCustomerCountry() != this.EcomOrderDeliveryCountry())) {
                    this.EcomOrderDeliveryCountry(this.EcomOrderCustomerCountry());                    
                }

                if (newValue == "Pickup") {
                    this.loadedChosenShipping(this.pickupShippingId());
                }
                else {
                    switch (Number(this.userType())) {
                        case 1:
                            this.loadedChosenShipping(this.privateShippingId());
                            break;
                        default:
                            this.loadedChosenShipping(this.companyShippingId());
                            break;
                    }
                }
            });

            this.EcomOrderCustomerCountry.subscribe((newVal) => {                
                if (this.altDelivery() != "Other" && (this.EcomOrderCustomerCountry() != this.EcomOrderDeliveryCountry())) {                    
                    this.EcomOrderDeliveryCountry(newVal);
                }
            });

            this.userType.subscribe((newValue) => {
                this.visibleFields([]); // empty array
                
                if (newValue == 1) {
                    this.isCompany(false);
                    this.visibleFields([
                        {
                            name: "reference",
                            required: false
                        }
                    ]);
                    if (this.altDelivery() != "Pickup") {
                        this.loadedChosenShipping(this.privateShippingId());
                    }
                    else {
                        this.loadedChosenShipping(this.pickupShippingId());
                    }
                }
                else if (newValue == 2) {
                    this.isCompany(true);
                    this.visibleFields([
                        {
                            name: "company",
                            required: true
                        },
                        {
                            name: "cvr",
                            required: true
                        },
                        {
                            name: "ean",
                            required: false
                        },
                        {
                            name: "reference",
                            required: true
                        }
                    ]);
                    if (this.altDelivery() != "Pickup") {
                        this.loadedChosenShipping(this.companyShippingId());
                    }
                    else {
                        this.loadedChosenShipping(this.pickupShippingId());
                    }
                }
                else if (newValue == 3) {
                    this.isCompany(false);
                    this.visibleFields([
                        {
                            name: "company",
                            required: true
                        },
                        {
                            name: "ean",
                            required: true
                        },
                        {
                            name: "invoicepay", 
                            required: false
                        },
                        {
                            name: "reference",
                            required: true
                        }
                    ]);
                    if (this.altDelivery() != "Pickup") {
                        this.loadedChosenShipping(this.companyShippingId());
                    }
                    else {
                        this.loadedChosenShipping(this.pickupShippingId());
                    }
                }

            });

            this.loadedChosenShipping.subscribe((newValue) => {
                // afterwards submit form
                this.submitForm();
            });

            this.deliveryText.subscribe((newtext) => {
                this.submitForm();
            });

        };

        public gtmInformationDataLayer() {
            var productDataDivs = $(".summary-orderline");
            var items = [];

            productDataDivs.each(function() {
                var productDataAttr = $(this).attr("data-product-info");
                var productData = JSON.parse(productDataAttr);
                var name = productData[0];
                var id = productData[1];
                var country = productData[2];
                var beforePrice = productData[3];
                var beforePriceVat = (beforePrice/100)*25;
                var beforePriceWithVat = beforePrice + beforePriceVat;
                var price = productData[4];
                var currency = productData[5];
                var brand = productData[6];
                var primaryGroup = productData[7];
                var quantity = productData[8];

                price = price.replace(",", ".");
                var priceParsed = parseFloat(price);
                var quantityParsed = parseInt(quantity);

                items.push({
                    item_name: name,
                    item_id: id,
                    affiliation: country,
                    discount: beforePriceWithVat,
                    price: priceParsed,
                    item_brand: brand,
                    item_category: primaryGroup,
                    //item_list_name: '[item list name]',
                    //item_list_id: '[item list id]',
                    //item_variant: '[item variant]',
                    //location_id: '[location_id]',
                    //index: '[index number]',
                    quantity: quantityParsed,
                    currency: currency
                })
            });

            console.log("Information 1", items);

            var windowAny = (window as any);
            windowAny.dataLayer.push({ ecommerce: null });
            windowAny.dataLayer.push({
                event: 'begin_checkout',
                ecommerce: {
                    items: items
                }
            });
        }

        private updateZip = (zip: string, city: KnockoutObservable<string>) => {
            return this.data.get("/Handlers/Firstweb.ERP.Users.ashx?cmd=getcity&zipcode=" + zip).then(function (response: IFirstWebERPService) {
                var ERPstatus = response.ERPStatus || null;
                if (ERPstatus) {
                    if (ERPstatus.Success) {
                        city(response.Data); // update City 
                    }
                    else {
                        this.logger.warning("Firstweb.ERP.Users failed with following error code: " + ERPstatus.Code);
                    }
                }
                else {
                    this.logger.warning("ERP status not found in Firstweb.ERP.Users.ashx");
                }
            });
        };

        public showAltDelivery: KnockoutComputed<boolean> = ko.computed(() => {
            return this.altDelivery() == "Other";
        });

        public getSelectTextValue = (obj: any, e: Event): void => {
            if (e) {
                if (e.target) {
                    var currentSelect: HTMLSelectElement = <HTMLSelectElement>e.target;
                    var currentSelectIndex: number = currentSelect.selectedIndex;
                    if (currentSelectIndex) {
                        var currentOption: HTMLOptionElement = <HTMLOptionElement>currentSelect.options[currentSelectIndex];
                        this.preferredWholesaler(currentOption.text);
                    }
                }
            }
        }

        public submitForm = (): void => {
            // submit form changes when changing payment methods etc 
            
            let myCheckoutForm = <HTMLFormElement>document.getElementById(this.currentFormId());
            if (myCheckoutForm !== null) {
                // if form exists submit
                this.pageIsUpdating(true); // trigger that form is submitting
                $(myCheckoutForm).trigger("ajaxSubmit");
            }
            else {
                // if all fails note to the developer that something is off
                this.logger.warning("remember to define the correct currentFormId (e.g 'ordersubmit') with initValue");
            }
        }
        
        public checkoutInit() {
            // Mobile dummy acceptance checkbox
            $("#EcomOrderCustomerAcceptedDummy").on("click", function() {
                const ecomOrderCustomerAccepted = $("#EcomOrderCustomerAccepted");
                ecomOrderCustomerAccepted.prop('checked', !ecomOrderCustomerAccepted.is(':checked'));
                $(".acceptance-text").addClass("hidden");
            });
            
            // Mobile dummy checkout button
            $("#OrderSubmitDummy").on("click", function() {
                const ecomCartNextStepBtn = $("#cartnextstepbtn");
                const ecomOrderCustomerAcceptedDummy = $("#EcomOrderCustomerAcceptedDummy");
                if (ecomOrderCustomerAcceptedDummy.prop('checked')) {
                    ecomCartNextStepBtn.trigger("click");
                } else {
                    $(".acceptance-text").removeClass("hidden");
                }
            });
        }

        public gtmDataLayer() {
            
            $("#cartnextstepbtn").on("click", function() {

                //this.gtmInformationDataLayer();
                
                var productDataDivs = $(".summary-orderline");
                var items = [];

                productDataDivs.each(function() {
                    var productDataAttr = $(this).attr("data-product-info");
                    var productData = JSON.parse(productDataAttr);
                    var name = productData[0];
                    var id = productData[1];
                    var country = productData[2];
                    var beforePrice = productData[3];
                    var beforePriceVat = (beforePrice/100)*25;
                    var beforePriceWithVat = beforePrice + beforePriceVat;
                    var price = productData[4];
                    var currency = productData[5];
                    var brand = productData[6];
                    var primaryGroup = productData[7];
                    var quantity = productData[8];

                    items.push({
                        item_name: name,
                        item_id: id,
                        affiliation: country,
                        discount: beforePriceWithVat,
                        price: price,
                        item_brand: brand,
                        item_category: primaryGroup,
                        //item_list_name: '[item list name]',
                        //item_list_id: '[item list id]',
                        //item_variant: '[item variant]',
                        //location_id: '[location_id]',
                        //index: '[index number]',
                        quantity: quantity,
                        currency: currency
                    })
                });

                console.log("Information 2", items);

                var windowAny = (window as any);
                windowAny.dataLayer.push({ ecommerce: null });
                windowAny.dataLayer.push({
                    event: 'add_payment_info',
                    ecommerce: {
                        items: items
                    }
                });
            });
        }
    }
}
